"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebContractListReviewsResponseSchema = exports.WebContractGetReviewResponseSchema = exports.WebContractReviewIdPathParamsSchema = exports.WebContractReviewQueryParamsSchema = exports.WebContractUpdateReviewRequestSchema = exports.WebContractCreateReviewRequestSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const ProductReviewSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    userId: zod_1.z.string(),
    productId: zod_1.z.string(),
    orderItemId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    rating: zod_1.z.number(),
    comment: zod_1.z.string(),
    images: zod_1.z.string().array(),
});
exports.WebContractCreateReviewRequestSchema = ProductReviewSchema.pick({
    orderItemId: true,
    rating: true,
    comment: true,
    images: true,
    productId: true,
});
exports.WebContractUpdateReviewRequestSchema = exports.WebContractCreateReviewRequestSchema.omit({ orderItemId: true });
exports.WebContractReviewQueryParamsSchema = shared_1.ContractPaginationQueryParamsSchema.extend({ slug: zod_1.z.string().optional() });
exports.WebContractReviewIdPathParamsSchema = zod_1.z.object({ reviewId: zod_1.z.string() });
exports.WebContractGetReviewResponseSchema = zod_1.z.object({ review: ProductReviewSchema });
exports.WebContractListReviewsResponseSchema = shared_1.ContractBaseListResponseSchema
    .extend({
    reviews: ProductReviewSchema.omit({
        createdAt: true,
        updatedAt: true,
    }).extend({
        createdAt: zod_1.z.string().datetime(),
        updatedAt: zod_1.z.string().datetime(),
    }).array(),
});
